import { Card, ErrorState, Skeleton } from '@shared/design-system/ui'
import type { Currency } from '@shared/contracts/enums'
import { SubscriptionMetricsSummary } from '@entities/subscription-metrics'
import type { SubscriptionMetrics } from '@entities/subscription-metrics'
import { sectionTitle } from './dashboard.css'

export function RecurrencePanel({
  data,
  selectedCurrency,
  isPending,
  isError,
  onRetry,
}: {
  data: SubscriptionMetrics | undefined
  selectedCurrency: Currency
  isPending: boolean
  isError: boolean
  onRetry: () => void
}) {
  if (isPending)
    return (
      <Card padding="md">
        <Skeleton height={190} />
      </Card>
    )
  if (isError || !data)
    return (
      <Card padding="md">
        <ErrorState onRetry={onRetry} />
      </Card>
    )
  return (
    <SubscriptionMetricsSummary
      metrics={data}
      currency={selectedCurrency}
      titleId="dashboard-subscriptions-title"
      header={
        <h2 id="dashboard-subscriptions-title" className={sectionTitle}>
          Recorrência
        </h2>
      }
    />
  )
}
